import { render } from "./B2bTableCierresContables.vue?vue&type=template&id=27f461ff&scoped=true&lang=pug"
import script from "./B2bTableCierresContables.vue?vue&type=script&lang=js"
export * from "./B2bTableCierresContables.vue?vue&type=script&lang=js"

import "./B2bTableCierresContables.vue?vue&type=style&index=0&id=27f461ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f461ff"]])

export default __exports__